import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Editor } from '@tinymce/tinymce-react';
import ImagePicker from '../../../Components/ImagePicker/ImagePicker';
import FilePicker from '../../../Components/FilePicker/FilePicker';
import './BookFormModal.css';
import './AdminForm.css';

const BookFormModal = ({ book, onSave, onClose }) => {
  const [activeTab, setActiveTab] = useState('alap'); // 'alap', 'tartalom', 'marketing'
  const [formData, setFormData] = useState(book);

  // Általános input kezelő (szöveg, checkbox, stb.)
  const handleChange = (e, path) => {
    const { value, type, checked } = e.target;
    const keys = path.split('.');
    
    setFormData(prev => {
      const newData = JSON.parse(JSON.stringify(prev));
      let pointer = newData;
      for (let i = 0; i < keys.length - 1; i++) {
        pointer = pointer[keys[i]];
      }
      pointer[keys[keys.length - 1]] = type === 'checkbox' ? checked : value;
      return newData;
    });
  };
  
  // Képválasztó kezelője
  const handleImageChange = (newValue, path) => {
    setFormData(prev => {
        const newData = JSON.parse(JSON.stringify(prev));
        let pointer = newData;
        const keys = path.split('.');
        for(let i=0; i<keys.length -1; i++) { pointer = pointer[keys[i]]; }
        pointer[keys[keys.length - 1]] = newValue;
        return newData;
    });
  };
  
  // Tömbök kezelője (textarea-ból)
  const handleArrayChange = (e, path) => {
    const value = e.target.value.split('\n').filter(line => line.trim() !== '');
    
    // Mivel a handleChange nem tud tömböt kezelni, itt egy egyszerűsített verziót használunk
    setFormData(prev => {
        const newData = JSON.parse(JSON.stringify(prev));
        // Feltételezzük, hogy a path egyetlen szint mély, pl. 'radioTransmissions'
        newData[path] = value;
        return newData;
    });
  };

  // TinyMCE szerkesztő kezelője
  const handleDescriptionChange = (content) => {
    setFormData(prev => ({ ...prev, description: content }));
  };

  const handleSave = () => {
    onSave(formData);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'tartalom':
        return (
          <div className="form-group-full">
            <label>Leírás (formázott)</label>
            <Editor
              apiKey='ihuzhtbtyuzbwks4d8nuyl9bmu1uq25scfmxd8gjgmmqc5qz'
              value={formData.description}
              onEditorChange={handleDescriptionChange}
              init={{
                height: 400, menubar: false, plugins: [ 'lists', 'link', 'code', 'help', 'wordcount' ],
                toolbar: 'undo redo | blocks | bold italic underline | removeformat | help',
                block_formats: 'Paragraph=p; Heading 2=h2; Heading 3=h3',
                skin: 'oxide-dark', content_css: 'dark',
                content_style: `:root {--accent-color: #d95525;} body { background-color: #101010; color: #e0e0e0; font-family: 'Roboto', sans-serif; line-height: 1.7;} h2, h3 { font-family: 'Oswald', sans-serif; color: var(--accent-color); border-bottom: 1px solid #444; padding-bottom: 5px; margin-top: 1.5rem;} a {color: var(--accent-color);} strong {color: #fff;}`
              }}
            />
          </div>
        );
      case 'marketing':
        return (
          <>
            <div className="form-group">
              <div className="label-wrapper">
                <label>Rádióüzenetek</label>
                <span className="label-description">Minden üzenet új sorba kerüljön.</span>
              </div>
              <textarea rows="8" value={(formData.radioTransmissions || []).join('\n')} onChange={(e) => handleArrayChange(e, 'radioTransmissions')}></textarea>
            </div>
            <div className="form-group">
                <div className="label-wrapper">
                    <label>Dicséretek (hamarosan)</label>
                </div>
                 <p style={{color: '#888', margin: 0}}>Ez a funkció a következő verzióban lesz elérhető.</p>
            </div>
          </>
        );
      case 'letoltesek':
        return (
          <>
            <p className="page-description">
              Itt adhatod meg a könyv letölthető verzióinak elérési útvonalát és a számlálók kezdőértékét.
              A fájlokat először töltsd fel a `public/downloads` mappába.
            </p>
            
            {/* PDF SZEKCIÓ */}
            <div className="form-group">
              <FilePicker 
                label="PDF Fájl"
                value={formData.downloads?.pdf?.url || ''}
                onChange={(newValue) => handleChange({target: {value: newValue}}, 'downloads.pdf.url')}
                accept=".pdf"
              />
            </div>
            <div className="form-group">
              <div className="label-wrapper">
                <label>PDF Letöltésszámláló</label>
                <span className="label-description">A számláló innen indul.</span>
              </div>
              <input 
                type="number" 
                value={formData.downloads?.pdf?.count || 0}
                onChange={(e) => handleChange(e, 'downloads.pdf.count')}
              />
            </div>

            <hr />

            {/* EPUB SZEKCIÓ */}
            <div className="form-group">
              <FilePicker 
                label="EPUB Fájl"
                value={formData.downloads?.epub?.url || ''}
                onChange={(newValue) => handleChange({target: {value: newValue}}, 'downloads.epub.url')}
                accept=".epub"
              />
            </div>
             <div className="form-group">
              <div className="label-wrapper">
                <label>EPUB Letöltésszámláló</label>
              </div>
              <input 
                type="number" 
                value={formData.downloads?.epub?.count || 0}
                onChange={(e) => handleChange(e, 'downloads.epub.count')}
              />
            </div>

            <hr />

            {/* MOBI SZEKCIÓ */}
            <div className="form-group">
              <FilePicker 
                label="MOBI Fájl"
                value={formData.downloads?.mobi?.url || ''}
                onChange={(newValue) => handleChange({target: {value: newValue}}, 'downloads.mobi.url')}
                accept=".mobi"
              />
            </div>
            <div className="form-group">
              <div className="label-wrapper">
                <label>MOBI Letöltésszámláló</label>
              </div>
              <input 
                type="number" 
                value={formData.downloads?.mobi?.count || 0}
                onChange={(e) => handleChange(e, 'downloads.mobi.count')}
              />
            </div>
          </>
        );
      default: // 'alap' fül
        return (
          <>
            <div className="form-group">
              <div className="label-wrapper"><label htmlFor="book-title">Cím</label></div>
              <input id="book-title" type="text" value={formData.title} onChange={(e) => handleChange(e, 'title')} />
            </div>
            <div className="form-group">
              <div className="label-wrapper"><label>ID</label><span className="label-description">Automatikus, nem módosítható.</span></div>
              <input type="text" value={formData.id} readOnly disabled />
            </div>
            <div className="form-group">
              <div className="label-wrapper"><label htmlFor="book-tagline">Mottó (tagline)</label></div>
              <input id="book-tagline" type="text" value={formData.tagline} onChange={(e) => handleChange(e, 'tagline')} />
            </div>
            <div className="form-group">
              <div className="label-wrapper"><label>Borítókép</label></div>
              <ImagePicker value={formData.coverImage} onChange={(newValue) => handleImageChange(newValue, 'coverImage')} />
            </div>
            <div className="form-group">
              <div className="label-wrapper"><label>Kiemelt állapot</label></div>
              <div className="checkbox-group single-checkbox">
                <input type="checkbox" id="isFeatured" checked={formData.isFeatured} onChange={(e) => handleChange(e, 'isFeatured')} />
                <label htmlFor="isFeatured">Ez a könyv jelenjen meg a Főoldalon</label>
              </div>
            </div>
          </>
        );
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-backdrop">
      <div className="book-form-modal-fullscreen">
        <div className="book-form-content">
          <div className="modal-header">
            <h2>{book.title ? `Szerkesztés: ${book.title}` : "Új Könyv"}</h2>
            <div className="modal-actions">
              <button onClick={onClose} className="cancel-button">Mégse</button>
              <button onClick={handleSave} className="save-button">Mentés</button>
            </div>
          </div>
          <div className="modal-tabs">
            <button className={`tab-button ${activeTab === 'alap' ? 'active' : ''}`} onClick={() => setActiveTab('alap')}>Alap Adatok</button>
            <button className={`tab-button ${activeTab === 'letoltesek' ? 'active' : ''}`} onClick={() => setActiveTab('letoltesek')}>Letöltések</button>
            <button className={`tab-button ${activeTab === 'tartalom' ? 'active' : ''}`} onClick={() => setActiveTab('tartalom')}>Tartalom</button>
            <button className={`tab-button ${activeTab === 'marketing' ? 'active' : ''}`} onClick={() => setActiveTab('marketing')}>Marketing & Hangulat</button>
          </div>
          <div className="modal-tab-content">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default BookFormModal;